import _ from "lodash";
import {LoanPayment} from "@/models/LoanPayment/LoanPayment";

export class LoanPayments {
  constructor() {
    /** @type {LoanPayment[]} */
    this.items = [];
  }

  /**
   * @returns {LoanPayment[]}
   */
  get paymentRequested() {
    return this.items.filter((payment) => {
      /** @type {LoanPayment} payment */
      return payment.isRequested();
    })
  }

  get nextPayment() {
    let pendingPayments = this.items.filter((p) => p.status !== "requested" && p.status !== "done");
    let pendingPaymentsOrdered = _.sortBy(pendingPayments, "order");

    if (pendingPaymentsOrdered.length > 0) {
      return pendingPaymentsOrdered[0];
    }
    return null;
  }

  add(loanPayment) {
    if (loanPayment.constructor === LoanPayment) {
      this.items.push(loanPayment)
    }
  }

  get totalAmount() {
    return _.sumBy(this.items, payment => payment.amount)
  }

  get totalPercentage() {
    return _.sumBy(this.items, payment => {
      return payment.paymentPercentage
    });
  }

  clear() {
    this.items = [];
  }
}
